import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { HelpCircle } from 'lucide-react';

interface TooltipLabelProps {
  label: string;
  tooltip: string;
}

const TooltipLabel: React.FC<TooltipLabelProps> = ({ label, tooltip }) => {
  return (
    <div className="flex items-center gap-1">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <button className="text-gray-400 hover:text-gray-600 focus:outline-none">
              <HelpCircle className="w-4 h-4" />
            </button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              // side="right" keeps the tooltip BESIDE the (?) icon instead of
              // above it. The default "top" rendered upward + leftward, bleeding
              // over the canvas and covering the panel's info message in narrow
              // right-edge panels (e.g. the TSL Block Editor). collisionPadding
              // + avoidCollisions (Radix default) flip it to a fitting side near
              // viewport edges. z-[60] keeps it above canvas block tooltips (z-50).
              className="max-w-xs bg-gray-900 text-white text-sm px-3 py-2 rounded shadow-lg z-[60]"
              side="right"
              align="center"
              sideOffset={6}
              collisionPadding={8}
            >
              {tooltip}
              <Tooltip.Arrow className="fill-gray-900" />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    </div>
  );
};

export default TooltipLabel;